
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useParams, useNavigate, Link } from "react-router-dom";

import React, { useEffect, useState, useMemo } from "react";
import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";

const ModifyItemMaster = () => {
   useAuthRedirect();
  const { id, branch } = useParams();
  const navigate = useNavigate();

  const [uom, setUom] = useState([])
  const [formData, setFormData] = useState({});

  /////////////////////////////////////////////////////////////
      const rawPerms = useMemo(() => localStorage.getItem("permissions") || localStorage.getItem("userPermissions"), []);
        const permsLoaded = !!rawPerms;
        
        //✅ Permission checks (safe even if perms not yet loaded; will be false)
        const canEdit = hasPermission("Item", "edit");
        /////////////////////////////////////////////////////////////
  

  useEffect(() => {
    {canEdit && (
      fetchVehiclePosition()
    )}
  }, [id, branch]);

  useEffect(() => {
    const fetchUom = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_addUom`);
        setUom(response.data.fetchUomList || []);
        console.log(response.data.fetchUomList);
        
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };
    fetchUom();
  }, []);

  // Fetch Vehicle Position Data
  const fetchVehiclePosition = async () => {
    try {
      Swal.fire({
                        title: "Fetching Item Details",
                        html: `
                          <div style="width: 100%; background: #e0e0e0; border-radius: 5px;">
                            <div style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); animation: progressBar 2s linear infinite;"></div>
                          </div>
                          <p style="margin-top: 10px; font-size: 14px;">Please wait while we fetch Item Details...</p>
                        `,
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                          const style = document.createElement("style");
                          style.innerHTML = `
                            @keyframes progressBar {
                              0% { width: 0% }
                              50% { width: 100% }
                              100% { width: 0% }
                            }
                          `;
                          document.head.appendChild(style);
                        },
                      });
      const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/itemMaster_editFetch/${id}/${branch}`);
      console.log("Fetched Vehicle Data:", response.data);


      if (response.data && response.data.position) {
        setFormData({
          code: response.data.position.itemmaster_code || "",
          itemName: response.data.position.itemmaster_name || "",
          uom: response.data.position.itemmaster_uom || "",
          price: response.data.position.itemmaster_price || "",
          type: response.data.position.itemmaster_type || "",
          opnNo: response.data.position.itemmaster_tariffHeading,
          location: response.data.position.itemmaster_location || "",
          partNo: response.data.position.itemmaster_drawingNumber || "",
          openingStock: response.data.position.itemmaster_openingStock,
          pUom: response.data.position.itemMaster_purchaseUom || "",
          lead: response.data.position.itemMaster_leadTime,
          conversion: response.data.position.itemMaster_PurchaseConversionQuantity,
          min: response.data.position.itemMaster_minimumStock,
          max: response.data.position.itemMaster_maximumStock,
          class: response.data.position.itemMaster_abcClass,
          
        })
      
    }
      Swal.close();
    } catch (error) {
      Swal.close();
                      console.error("Error fetching Item Details. Please try again:", error);
                      Swal.fire({
                        icon: "error",
                        title: "Oops!",
                        text: "Error fetching Purchase No. Please try again",
                      });
    }
  };

  // Handle Input Change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

 const handleSubmit = async (e) => {
  e.preventDefault();

  // === VALIDATION START ===
  // Numeric required fields
  const numericFields = [
    { key: "conversion", label: "Conversion" },
    { key: "min", label: "Minimum Stock" },
    { key: "max", label: "Maximum Stock" },
    { key: "lead", label: "Lead Time" },
    { key: "price", label: "Price" },
    { key: "openingStock", label: "Opening Stock" },
  ];

  const numericValues = {}; // store parsed numbers for later checks

  for (let field of numericFields) {
    const rawValue = formData[field.key];

    if (rawValue === "" || rawValue === null || rawValue === undefined) {
      Swal.fire("Validation Error", `${field.label} should not be empty.`, "warning");
      return;
    }

    const numValue = rawValue;

    if (isNaN(numValue)) {
      Swal.fire("Validation Error", `${field.label} must be a number.`, "warning");
      return;
    }

    numericValues[field.key] = numValue;
  }

  // Extra validation: min should not be greater than max
  if (numericValues.min > numericValues.max) {
    Swal.fire(
      "Validation Error",
      "Minimum Stock cannot be greater than Maximum Stock.",
      "warning"
    );
    return;
  }

  // Text required fields
  const textFields = [
    { key: "pUom", label: "Purchase UOM" },
    { key: "uom", label: "UOM" },
    { key: "type", label: "Type" },
    { key: "opnNo", label: "OPN No" },
    { key: "location", label: "Location" },
    { key: "partNo", label: "Part Number" },
  ];

  for (let field of textFields) {
    const value = formData[field.key];
    if (!value || value.trim() === "") {
      Swal.fire("Validation Error", `${field.label} should not be empty.`, "warning");
      return;
    }
  }
  // === VALIDATION END ===

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

   const updatedData = {
  itemName: formData.itemName,
  code: id,
  price: numericValues.price,
  opnNo: formData.opnNo,
  location: formData.location,
  openingStock: numericValues.openingStock,
  pUom: formData.pUom,
  uom: formData.uom,
  lead: numericValues.lead,
  conversion: numericValues.conversion,
  partNo: formData.partNo,   // varchar
  min: numericValues.min,
  max: numericValues.max,
  rg: formData.rg,
  classType: formData.class,
  type: formData.type,
};

    console.log("Submitting Data:", updatedData);

    const response = await axios.put(
      `https://rfs2.infraconsoft.net.in/api/itemMaster_modify/${id}/${branch}`,
      updatedData
    );

    if (response.data.success) {
      Swal.fire({
        title: "Success!",
        text: "Updated successfully.",
        icon: "success",
        width: "500px",
        height: "40vh",
        draggable: true,
      }).then(() => {
        navigate(`/inventory/itemmasterviewnew`);
      });
    } else {
      Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
  } catch (error) {
    console.error("Error updating item master:", error);
    Swal.fire("Error", "An error occurred while updating the item master.", "error");
  }
};



  if (!canEdit) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }

  

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Item Master - Modify</h2>
                    <Link to='/inventory/itemmasterviewnew'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>Item Code :</label>
                <input type="text" name="code" value={formData.code} />
              </div>
              <div className="form-group">
                <label>Item Name :</label>
                <input type="text" name="name" value={formData.itemName} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Branch Name :</label>
                <input type="text" name="branch" value={branch} readOnly />
              </div>
              <div className="form-group">
                <label>Item Master Location :</label>
                <input type="text" name="location" value={formData.location} readOnly />
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>Uom :</label>
                <select name="uom" value={formData.uom} onChange={handleInputChange} >
                  <option value="">-- Select UOM --</option>
                  {uom.map((item, index) => (
                    <option key={index} value={item.uommaster_shortname}>
                      {item.uommaster_shortname}
                    </option>
                  ))}
                </select>
            </div>

            <div className="form-group">
                <label>Purchase UOM:</label>
                <select name="pUom" value={formData.pUom} onChange={handleInputChange} >
                  <option value="">-- Select UOM --</option>
                  {uom.map((item, index) => (
                    <option key={index} value={item.uommaster_shortname}>
                      {item.uommaster_shortname}
                    </option>
                  ))}
                </select>
              </div>
            </div>


            
              <div className="form-row">
                <div className="form-group">
                  <label>Conversion :</label>
                  <input type="text" name="conversion" value={formData.conversion} onChange={handleInputChange}  />
                </div>
                <div className="form-group">
                  <label>Lead Time :</label>
                  <input type="text" name="lead" value={formData.lead} onChange={handleInputChange}  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Price :</label>
                  <input type="text" name="price" value={formData.price} onChange={handleInputChange}  />
                </div>
                <div className="form-group">
                  <label>Type :</label>
                  <input type="text" name="type" value={formData.type} onChange={handleInputChange}  />
                </div>
              </div>
            
              <div className="form-row">
                <div className="form-group">
                  <label>Tariff Heading/ OPN No :</label>
                  <input type="text" name="opnNo" value={formData.opnNo} onChange={handleInputChange}  />
                </div>
                <div className="form-group">
                  <label>Part No :</label>
                  <input type="text" name="partNo" value={formData.partNo} onChange={handleInputChange}  />
                </div>
              </div>
            

            <div className="form-row">
              <div className="form-group">
                <label>Stock (Minimum) :</label>
                <input type="text" name="min" value={formData.min} onChange={handleInputChange}  />
              </div>
              <div className="form-group">
                <label>Stock (Maximum) :</label>
                <input type="text" name="max" value={formData.max} onChange={handleInputChange} />
              </div>
            </div>



            <div className="form-row">
              <div className="form-group">
                <label>Opening Stock:</label>
                <input type="text" name="openingStock" value={formData.openingStock}  onChange={handleInputChange} />
              </div>
              <div className="form-group">
                <label>Class :</label>
                <select name="class" value={formData.class} onChange={handleInputChange} >
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                </select>
              </div>
            </div>

            <div className="form-row">
            <div className="form-group">
                <label>RG23 Type :</label>
                <select name="rg" value={formData.rg} onChange={handleInputChange} >
                <option value="RG-23A">RG-23A</option>
                  <option value="RG-23C">RG-23C</option>
                  <option value="Others">Others</option>
                </select>
              </div>
              <div className="form-group">
                <label></label>
                <input type="hidden" />
              </div>
            </div>


            <div className="btn-cls">
              <button type="submit" className="submit-btn">Update</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ModifyItemMaster;
